import { render, staticRenderFns } from "./Zcap1.vue?vue&type=template&id=2efb9ce8&scoped=true&"
import script from "./Zcap1.vue?vue&type=script&lang=ts&"
export * from "./Zcap1.vue?vue&type=script&lang=ts&"
import style0 from "./Zcap1.vue?vue&type=style&index=0&id=2efb9ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb9ce8",
  null
  
)

export default component.exports